import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>Brooke Smith</title>
                    <meta name="description" content="This is a site that illustrates Brooke's work and projects" />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
